import styled from 'styled-components';
import { colors } from '../../../../theme/modules/colors';
import { Text } from '../../../Text';
import { BaseContainer } from '../../../BaseContainer';
const Container = styled(BaseContainer).withConfig({ displayName: "vui--Container", componentId: "vui--yx82xe" }) `display:flex;flex-direction:row;justify-content:flex-start;align-items:center;`;
const StyledText = styled(Text).withConfig({ displayName: "vui--StyledText", componentId: "vui--gffv6m" }) `width:100%;padding:8px 16px;cursor:pointer;&:hover{color:${colors.secondary.blue.base};background:${colors.neutral.grey.lightest};}`;
export { StyledText as Text, Container };
//# sourceMappingURL=styled.js.map